import React from "react";
import { FREQ, STRUCT, SOMATIC, GERMLINE, OTHER } from "./dbs";

export const HIGH_PERF = "high-performance";
export const LOW_POWER = "low-power";
export const DEF_QUALITY = "default";
export const MAX_QUALITY = "maximum";
export const HIGH_QUALITY = "high";
export const MED_QUALITY = "medium";
export const LOW_QUALITY = "low";
export const MIN_QUALITY = "min";

// color scales
export const READ_RATIO_CL = "readratio_colorScale";
export const PATHOGENICITY_CL = "pathogenicity_colorScale";
export const CONSERVATION_CL = "conservation_colorScale";
export const ROH_CL = "roh_colorScale";
export const PHASING_CL = "phasing_colorScale";
export const FREQ_CL = "frequency_colorScale";
export const STRUCT_CL = "struct_colorScale";
export const SOMATIC_CL = "somatic_colorScale";
export const GERMLINE_CL = "germline_colorScale";
export const OTHER_CL = "other_colorScale";
export const SELECTION_CL = "selection_colorScale";
export const COVERAGE_CL = "coverage_colorScale";
export const CALL_CL = "call_colorScale";
export const TRANSCRIPT_CL = "transcript_colorScale";
export const PATHOGENICITY_CL_DELLY = "delly_pathogenicity_colorScale";
export const COVERAGE_CL_DELLY = "delly_coverage_colorScale";

export const IMPACT_NULL_VARS_CL = "impact_null_vars_colorScale";
export const IMPACT_OTHER_CL = "impact_other_colorscale";

export const SCALE_LABELS = {
  [TRANSCRIPT_CL]: "Transcripts",
  [READ_RATIO_CL]: "Reads",
  [COVERAGE_CL]: "Coverage",
  [CALL_CL]: "CNV Calls",
  [PATHOGENICITY_CL]: "Pathogenicity",
  [PATHOGENICITY_CL_DELLY]: "Pathogenicity",
  [COVERAGE_CL_DELLY]: "Coverage",
  [CONSERVATION_CL]: "Conservation",
  [ROH_CL]: "RoH",
  [FREQ_CL]: "Frequency DBs",
  [STRUCT_CL]: "Structural DBs",
  [SOMATIC_CL]: "Somatic DBs",
  [GERMLINE_CL]: "Germline DBs",
  [OTHER_CL]: "Other DBs",
  [PHASING_CL]: "Phasing Groups",
  [IMPACT_NULL_VARS_CL]: "Null Variants",
  [IMPACT_OTHER_CL]: "Other Coding Impacts",
};

export const DB_TO_CL = {
  [FREQ]: FREQ_CL,
  [STRUCT]: STRUCT_CL,
  [SOMATIC]: SOMATIC_CL,
  [GERMLINE]: GERMLINE_CL,
  [OTHER]: OTHER_CL,
};

// themes
export const DARK = "dark";
export const LIGHT = "light";
export const SYSTEM = "system";

// full screen
export const NATIVE = "native";
export const WINDOW = "window";

// antialising
export const ANTIALIASING = "antialiasing";
export const NO_ANTIALIASING = "no-antialiasing";

// gesture controll
export const COOPERATIVE = "cooperative";
export const GREEDY = "greedy";

export const POWER_OPTS = [HIGH_PERF, LOW_POWER];

export const QUALITY_OPTS = [
  MAX_QUALITY,
  HIGH_QUALITY,
  MED_QUALITY,
  LOW_QUALITY,
  MIN_QUALITY,
];

export const FULLSCREEN_MODE_OPTS = [NATIVE, WINDOW];

export const GESTURE_OPTS = [COOPERATIVE, GREEDY];

export const THEME_OPTIONS = [DARK, LIGHT, SYSTEM];
export const THEME_LABELS = {
  [DARK]: "Dark Theme",
  [LIGHT]: "Light Theme",
  [SYSTEM]: "System Theme",
};
export const GESTURE_LABELS = {
  [COOPERATIVE]: "Hold CTRL and scroll to zoom",
  [GREEDY]: "Click within the graph to activate zoom by scrolling.",
};

export const FULLSCREEN_MODE_LABELS = {
  [NATIVE]: "Native full screen window",
  [WINDOW]: "Expand to current window size",
};

export const ANTIALIASING_MODE_LABELS = {
  [ANTIALIASING]: "Antialising: Higher quality / Lower performance",
  [NO_ANTIALIASING]: "No Antialiasing: Lower quality / Higher performance",
};

export const GESTURE_HELP = {
  [COOPERATIVE]: () => (
    <div className="tw-tracking-wider tw-p-2">
      <div className="tw-text-sm tw-mb-2">
        Use <b>CTRL + SCROLL</b> to zoom.
      </div>
      <div className="tw-text-xs">
        <div>
          1. Vertically scroll the graph by SCROLL + <b>SHIFT</b>
        </div>
        <div>
          2. Zoom with <b className="tw-not-italic">multitouch</b> or{" "}
          <b className="tw-not-italic">touch screen gestures</b>.
        </div>
      </div>
    </div>
  ),

  [GREEDY]: () => (
    <div className="tw-tracking-wider tw-p-2">
      <div className="tw-text-sm tw-mb-2">
        Use <b>SCROLL</b> to zoom.
      </div>
      <div className="tw-text-xs">
        <div>
          1. Vertically scroll the graph by SCROLL + <b>SHIFT</b>
        </div>
        <br />
        <div>
          2. Zoom with <b className="tw-not-italic">multitouch</b> or{" "}
          <b className="tw-not-italic">touch screen gestures</b>
        </div>
      </div>
    </div>
  ),
};

export const POWER_LABELS = {
  [HIGH_PERF]: "High Performance",
  [LOW_POWER]: "Low Power",
};

export const QUALITY_LABELS = {
  [MAX_QUALITY]: "Maximum",
  [HIGH_QUALITY]: "High",
  [MED_QUALITY]: "Medium",
  [LOW_QUALITY]: "Low",
  [MIN_QUALITY]: "Minimum",
};

export const THREE_KEYS = {
  [HIGH_PERF]: "high-performance",
  [LOW_POWER]: "low-power",
  [MAX_QUALITY]: 1,
  [HIGH_QUALITY]: 0.88,
  [MED_QUALITY]: 0.75,
  [LOW_QUALITY]: 0.62,
  [MIN_QUALITY]: 0.5,
};
